module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-2 py-0 kios-item"
  }, [(_vm.loading) ? _c('content-placeholders', {
    staticClass: "mt-3"
  }, [_c('content-placeholders-text', {
    attrs: {
      "lines": 10
    }
  })], 1) : _c('div', [_c('v-layout', {
    staticClass: "wrap pb-3"
  }, [_c('div', {
    staticClass: "pb-2",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('v-chip', {
    staticClass: "mx-0 my-0",
    staticStyle: {
      "height": "px"
    },
    attrs: {
      "label": "",
      "color": _vm.getColor(_vm.serviceDetail.maxLevel),
      "text-color": "white"
    }
  }, [_vm._v("\n          Mức độ " + _vm._s(_vm.serviceDetail.maxLevel) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(100% - 100px)"
    }
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.serviceDetail.serviceName))])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-0"
  }, [_c('v-tabs', {
    attrs: {
      "color": "cyan",
      "dark": "",
      "slider-color": "yellow"
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tab', {
    key: "1",
    staticClass: "mr-2",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v(" Thông tin chung ")]), _vm._v(" "), _c('v-tab', {
    key: "2",
    staticClass: "mr-2",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v(" Trình tự thực hiện")]), _vm._v(" "), _c('v-tab', {
    key: "3",
    staticClass: "mr-2",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v(" Thành phần hồ sơ ")]), _vm._v(" "), _c('v-tab', {
    key: "4",
    staticClass: "mr-2",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v(" Yêu cầu điều kiện ")]), _vm._v(" "), _c('v-tab-item', {
    key: "1",
    staticClass: "wrap-scroll wrap-scroll-sevice"
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "px-0 py-0"
  }, [_c('div', {
    staticClass: "table-detail-domain table-bordered"
  }, [_c('div', {
    staticClass: "table__overflow"
  }, [_c('table', {
    staticClass: "datatable table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Mã thủ tục")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.serviceDetail.serviceCode))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Cơ quan quản lý")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.serviceDetail.administrationName))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Lĩnh vực")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.serviceDetail.domainName))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Cách thực hiện")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.methodText)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Thời gian giải quyết")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.durationText)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Đối tượng")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.applicantText)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Kết quả giải quyết")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.resultText)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Lệ phí")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.feeText)
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v("Căn cứ pháp lý")])]), _vm._v(" "), _c('td', {
    staticClass: "pt-2"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.regularText)
    }
  })])])])])])])])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "2",
    staticClass: "wrap-scroll wrap-scroll-sevice"
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.processText)
    }
  })])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "3",
    staticClass: "wrap-scroll wrap-scroll-sevice"
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.dossierText)
    }
  })])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "4",
    staticClass: "wrap-scroll wrap-scroll-sevice"
  }, [_c('v-card', [_c('v-card-text', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceDetail.conditionText)
    }
  })])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7e6cf8a8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e6cf8a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChiTietThuTuc.vue
// module id = 534
// module chunks = 1